import { SERVICES, svcDisplayColor } from '../constants.js'

export default function Badge({ id, bgMode = 'dark' }) {
  const s = SERVICES.find(x => x.id === id)
  if (!s) return null
  const color = svcDisplayColor(s, bgMode)
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 3,
      background: color + '22', border: `1px solid ${color}44`,
      color: color, borderRadius: 5, padding: '2px 7px',
      fontSize: 10, fontWeight: 800, letterSpacing: '0.07em',
      textTransform: 'uppercase', whiteSpace: 'nowrap', flexShrink: 0,
    }}>
      {s.logo} {s.short}
    </span>
  )
}
